import { Controller } from "@hotwired/stimulus"

// Dark-mode toggle. Replaces the ~400-character inline `onclick` the DashWind
// shell shipped with, and is mounted on more than one element (topbar dropdown
// item + sidebar footer button), so it must be stateless.
//
// Deliberately NO `connect()`: the anti-FOUC IIFE in <head> has already read
// localStorage and stamped `dark` on <html> before this bundle even parses.
// Writing the class again here would run after first paint and reintroduce the
// flash it exists to prevent. Every read of "is it dark right now?" comes from
// the DOM at click time, never from a value cached at connect — two toggles on
// one page must never disagree about the current state.
//
// Storage: `theme` is ours ('dark' | 'light'). `dashwind-html-demo1` is the
// DashWind theme's own blob ({ skin, sidebar, header, ... }); we MIRROR our
// value into its `.skin` key when the key already exists so the two never
// disagree, but we never create it — seeding it is the head IIFE's job.
// Every localStorage access is wrapped: Safari private mode throws on write,
// and a browser with site data blocked throws on read.
export default class extends Controller {
  toggle() {
    const html = document.documentElement
    const isDark = html.classList.toggle("dark")
    const theme = isDark ? "dark" : "light"

    this.persist(theme)
  }

  persist(theme) {
    try {
      localStorage.setItem("theme", theme)
    } catch (e) {
      // Storage unavailable (private mode, blocked site data) — the class on
      // <html> is already flipped, so the page is correct for this pageview.
    }

    try {
      const key = "dashwind-html-demo1"
      const raw = localStorage.getItem(key)
      if (!raw) return

      const settings = JSON.parse(raw)
      if (settings.skin === theme) return

      settings.skin = theme
      localStorage.setItem(key, JSON.stringify(settings))
    } catch (e) {
      // Unavailable or unparseable — leave the DashWind blob alone.
    }
  }
}
